import React, { useState } from 'react';
import { Expandable } from '@gjensidige/core-expandable';
import { useCmsContext } from '@gjensidige/service-cms';

import { useStepsStatus } from '../../hooks/useStepsStatus';
import { CheckListItems } from '../../types';
import { Step } from '../../types/enums';
import styles from './CheckWrapper.module.scss';
import StepsMobileNav from './StepsMobileNav';

interface Props {
  checkList: CheckListItems;
  onNavigationClick: (step: Step) => void;
}

const StepsMobile = ({ checkList, onNavigationClick }: Props) => {
  const { allSteps, currentStep } = useStepsStatus();
  const { getText } = useCmsContext();
  const [isOpen, setOpen] = useState(false);

  const handleNavigationClick = (step: Step) => {
    toggleExpandable();
    onNavigationClick(step);
  };

  const toggleExpandable = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <Expandable
      ariaControlId="checklist"
      colored={false}
      open={isOpen}
      wrapperClassName={styles.expandable}
      buttonClassName={styles.expandableButton}
      onClick={toggleExpandable}
    >
      {{
        header: (
          <span className={styles.expandableHeader}>
            <span className={styles.circle}>{`${
              currentStep + 1
            }/${allSteps}`}</span>
            {getText('housing.check.title')}
          </span>
        ),
        content: (
          <StepsMobileNav
            checkList={checkList}
            onItemClick={handleNavigationClick}
          />
        )
      }}
    </Expandable>
  );
};

export default StepsMobile;
